import { type AnalyticsEvent } from '@backstage/core-plugin-api';
import { type MetricRequest } from '@internal/plugin-neo4j-analytics-common';

import { BaseAnalyticsEventHandler } from './types';

export class DiscoverEventHandler extends BaseAnalyticsEventHandler {
  readonly eventName = 'discover';
  readonly metricName = this.eventName;

  canHandle(action: string): boolean {
    return action === this.eventName;
  }

  handle(event: AnalyticsEvent): MetricRequest[] {
    if (!this.canHandle(event.action)) {
      return [];
    }

    const name = this.getMetricName(this.metricName);

    const metricRequests: MetricRequest[] = [
      {
        kind: 'counter',
        name,
        value: 1,
        attributes: {
          extension: event.context.extension,
          to: event.attributes?.to || this.sentinelMissingValue,
          link_text: event.subject,
          // Value is singular, hence `search_type`
          search_type: event.context.searchTypes || this.sentinelMissingValue,
        },
        options: {
          description: 'Total number of search results clicked',
          unit: '1',
          valueType: 'int',
        },
      },
    ];

    if (event.value) {
      metricRequests.push({
        kind: 'histogram',
        name: `${name}.rank`,
        value: event.value,
        options: {
          description: 'Search result clicked rank distribution',
          unit: '1',
          valueType: 'int',
          advice: {
            explicitBucketBoundaries: [1, 5, 10],
          },
        },
      });
    }

    return metricRequests;
  }
}
